export type LandingPageSection = { id: string; hidden: boolean };
export type MarketLandingPageLayout = {
    mode: 'Standard' | 'Regulatory';
    standard: LandingPageSection[];
    regulatory: LandingPageSection[];
    configuredPageTypes?: ('Standard' | 'Regulatory')[];
    revisionTokens?: Partial<Record<'Standard' | 'Regulatory', string>>;
};

export const sectionLabels: Record<string, string> = {
    header: 'Header',
    'product-image': 'Product Image',
    'product-name': 'Product Name and Manufacturer',
    'product-overview': 'Product Overview',
    'package-details': 'Package Details',
    'batch-test-results': 'Batch Test Results',
    cannabinoids: 'Cannabinoids',
    terpenes: 'Terpenes',
    'product-details-about-brand': 'Product Details / About Brand',
    resources: 'Resources',
    footer: 'Footer',
};

export const regulatorySectionIds = [
    'product-image', 'product-name', 'product-overview', 'package-details', 'batch-test-results',
    'cannabinoids', 'terpenes', 'product-details-about-brand', 'resources',
];
export const standardSectionIds = [
    'product-image', 'product-name', 'product-overview', 'batch-test-results',
    'cannabinoids', 'terpenes', 'package-details', 'resources', 'product-details-about-brand',
];

export function normalizeLandingPageLayout(value?: Partial<MarketLandingPageLayout> | null): MarketLandingPageLayout {
    const normalize = (sections: LandingPageSection[] | undefined, ids: string[]) => {
        const seen = new Set<string>();
        const result: LandingPageSection[] = [];
        if (Array.isArray(sections)) {
            for (const section of sections) {
                if (section && ids.includes(section.id) && !seen.has(section.id)) {
                    seen.add(section.id);
                    result.push({ id: section.id, hidden: section.hidden === true });
                }
            }
        }
        for (const id of ids) if (!seen.has(id)) result.push({ id, hidden: false });
        return result;
    };
    return {
        mode: value?.mode === 'Regulatory' ? 'Regulatory' : 'Standard',
        standard: normalize(value?.standard, standardSectionIds),
        regulatory: normalize(value?.regulatory, regulatorySectionIds),
        configuredPageTypes: value?.configuredPageTypes
            ? [...new Set(value.configuredPageTypes.filter((mode) => mode === 'Standard' || mode === 'Regulatory'))]
            : value?.standard && value?.regulatory ? ['Standard', 'Regulatory'] : [],
        revisionTokens: value?.revisionTokens ?? {},
    };
}